/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Pro_NameInputs */

const en_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const de_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fr_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const it_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const nl_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const pl_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fi_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const da_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const sv_pricing_plan_pro_name = /** @type {(inputs: Pricing_Plan_Pro_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Pricing_Plan_Pro_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_pro_name = /** @type {((inputs?: Pricing_Plan_Pro_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Pro_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_pro_name(inputs)
	if (locale === "fr") return fr_pricing_plan_pro_name(inputs)
	if (locale === "es") return es_pricing_plan_pro_name(inputs)
	if (locale === "it") return it_pricing_plan_pro_name(inputs)
	if (locale === "nl") return nl_pricing_plan_pro_name(inputs)
	if (locale === "pl") return pl_pricing_plan_pro_name(inputs)
	if (locale === "fi") return fi_pricing_plan_pro_name(inputs)
	if (locale === "da") return da_pricing_plan_pro_name(inputs)
	if (locale === "sv") return sv_pricing_plan_pro_name(inputs)
	return en_pricing_plan_pro_name(inputs)
});